import React from 'react'
import { GiPhotoCamera } from "react-icons/gi"
import './gallery.css'
import useAppContext from '../../hook/useAppContext'
import GallerySlide from './GallerySlide'

const Gallery = () => {

      const {user} = useAppContext()
      const {images} = user 

      if(images.code) return 

      return (
            <div className="gallery_content">
                  <div className="gallery_title flex">
                        <div className="gallery_title__icon flex"><GiPhotoCamera /></div>
                  </div>
                  <div className="gallery_wrapper flex">
                        <div className="gallery_wrapper__box">
                              <GallerySlide images={images} />
                        </div>
                  </div>
            </div>
      )
}

export default Gallery
